import { Controller } from '@hotwired/stimulus';

const TRACK_LAYOUT_SETTLING_MS = 3000;

export default class extends Controller {
  connect() {
    this.onLayoutSettled = () => this.scrollIntoView();
    window.addEventListener('load', this.onLayoutSettled);
    document.addEventListener('turbo:frame-load', this.onLayoutSettled);
    this.element.addEventListener('transitionend', this.onLayoutSettled);
    this.trackingTimeout = setTimeout(() => this.stopTracking(), TRACK_LAYOUT_SETTLING_MS);

    requestAnimationFrame(() => {
      this.element.dispatchEvent(new CustomEvent('collapsable-section:expand'));
      this.scrollIntoView();
    });
  }

  disconnect() {
    this.stopTracking();
  }

  scrollIntoView() {
    this.element.scrollIntoView({ block: 'start' });
  }

  stopTracking() {
    clearTimeout(this.trackingTimeout);
    window.removeEventListener('load', this.onLayoutSettled);
    document.removeEventListener('turbo:frame-load', this.onLayoutSettled);
    this.element.removeEventListener('transitionend', this.onLayoutSettled);
  }
}
